
import {smsApi} from '@/api';
import {userApi} from '@/api';
import {Vue, Component, Emit} from 'vue-property-decorator';
import {FormModel} from 'ant-design-vue';

@Component({
    components: {}
})
export default class Home extends Vue {
    codeSvg = '';
    captchaKey = '';
    form: any = {
        password: '',
        repeatPassword: '',
        verificationCode: ''
    };
    errorVerifyCode: boolean = false;
    errorAccountPassword: boolean = false;
    errorPassword: boolean = false;
    resetSuccess: boolean = false;
    buttonName: string = '获取验证码';
    ruleFormRules: object = {
        verificationCode: [{required: true, message: '请输入验证码'}],
        password: [{validator: this.validatePassword, trigger: ['change', 'blur']}],
        repeatPassword: [{validator: this.validateRepeatPassword, trigger: ['change', 'blur']}]
    };

    get username() {
        return (this.$route.query.username as string) || '';
    }
    validatePassword(rule: any, value: any, callback: any) {
        if (!value) callback('请输入密码');
        else if (value && !/^[A-Za-z0-9_]{6,}$/.test(value)) callback('密码须设置字母、数字、下划线任意一种方式，至少6位');
        else callback();
    }
    validateRepeatPassword(rule: any, value: any, callback: any) {
        const form = this.form;
        if (!value) callback('请输入确认密码');
        else if (value && value !== form.password && value.length >= 6) callback('密码两次输入不一致');
        else callback();
    }
    getCaptcha() {
        let me = this;
        userApi.getGraphicCode({
            context: me,
            success(data: any, parameters: any) {
                me.captchaKey = data.data.captchaKey;
                me.codeSvg = data.data.imageData;
            }
        });
    }
    reloadCaptcha() {
        let me = this;
        userApi.refreshGraphicCode({
            context: me,
            urlParams: {captchaKey: me.captchaKey},
            success(data: any, parameters: any) {
                me.codeSvg = data.data.imageData;
            }
        });
    }
    submitForm() {
        let me = this;
        let form = this.$refs.refForm as FormModel;
        form.validate(valid => {
            if (valid) {
                userApi.changeUserPwd({
                    context: me,
                    data: {
                        username: this.username,
                        oldPwd: '123456',
                        newPwd: me.form.password,
                        code: me.form.verificationCode,
                        captchaKey: me.captchaKey
                    },
                    success(data: any, parameters: any) {
                        console.log(JSON.stringify(data));
                        if (!data.data || data.data != 'success') {
                            //验证成功返回ture  失败返回false
                            me.$message.error('修改密码失败！');
                            return;
                        }
                        me.resetSuccess = true;
                        me.$router.replace({
                            name: 'Login',
                            params: {
                                username: me.username,
                                password: me.form.password
                            }
                        });
                    },
                    error(data: any, message: any, parameters: any) {
                        me.reloadCaptcha();
                        if (data.code === 90000) {
                            // 验证码错误
                            me.errorVerifyCode = true;
                        } else if (data.code === 90002) {
                            // 新密码和旧密码相同
                            me.errorPassword = true;
                        } else {
                            // 账号或旧密码错误
                            me.errorAccountPassword = true;
                        }
                    }
                });
            } else {
                return false;
            }
        });
    }
    cleanVerifyCodeError() {
        this.errorVerifyCode = false;
    }
    cleanPasswordError() {
        this.errorAccountPassword = false;
        this.errorPassword = false;
    }
    mounted() {}
    created() {
        this.getCaptcha();
    }
}
